export default "__VITE_ASSET__odrIfWfH__"